module.exports = __webpack_public_path__ + "static/media/gfh78678.55da8e1f.png";